import Page, { getServerSideProps as getProps } from '../posts/index';
export const getServerSideProps = getProps;
export default Page;